// src/pages/Appli/AppliAdmin/users-admin/ui/RolePill.jsx

import React from "react";

import { getRoleMeta } from "../utils/usersAdmin.utils";

export default function RolePill({ roleId }) {
  const role = getRoleMeta(roleId);

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${role.className}`}
    >
      {role.name}
    </span>
  );
}